"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var VerificationCard_1 = __importDefault(require("./VerificationCard"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var profile_api_1 = require("@l2p/profile-api");
var KycStatus_1 = __importDefault(require("./KycStatus"));
var VerificationContent = function () {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(KycStatus_1.default, null),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement(VerificationCard_1.default, { type: profile_api_1.DocumentTypeEnum.Identity, icon: "/img/icons/verification/identity.svg" }),
            react_1.default.createElement(VerificationCard_1.default, { type: profile_api_1.DocumentTypeEnum.Address, icon: "/img/icons/verification/address.svg" }),
            react_1.default.createElement(VerificationCard_1.default, { type: profile_api_1.DocumentTypeEnum.Payment, icon: "/img/icons/verification/payment.svg" }))));
};
exports.default = VerificationContent;
